<template>
  <div id="app">
    <!-- <pre>{{ imagesData.location }}</pre> -->
    <!-- <img style="width: 600px; height: 350px" :src="uiElements" /> -->
    
    <tui-image-editor
      ref="tuiImageEditor"
      tabindex="-1" 
      :options="options"
      @addText="onAddText"
      @loadImageFromURL="onLoadImageFromURL"
    ></tui-image-editor>

    <vs-row class="mt-2"
      ><vs-spacer />
      <vs-button
        style="width: 80px; border-radius: 20px"
        class="mr-2"
        @click="loadImageFromURL"
        color="success"
        type="filled"
        >Save</vs-button
      >
      <vs-button
        style="width: 80px; border-radius: 20px"
        color="dark"
        @click="closeeditImage()"
        type="flat"
        >Close</vs-button
      ></vs-row
    >
    <!-- <vs-button
      class="brdbtn"
      color="success"
      @click="loadImageFromURL"
      type="filled"
      >Save</vs-button
    >
    <vs-button class="brdbtn" color="dark" type="flat">Close</vs-button> -->
  </div>
</template> 

<script>
// Import FilePond plugins
// Please note that you need to install these plugins separately
import fs from "fs";
import { ImageEditor } from "@toast-ui/vue-image-editor";
// Load Style Code
import "tui-image-editor/dist/tui-image-editor.css";
import Buffer from "buffer";
export default {
  name: "FilePondDemo",
  props: { imagesData: Array, closeeditImage: Function },
  data: function () {
    return {
      myFiles: [],
      uiElements: "",
      useDefaultUI: false,
      options: {
        // for tui-image-editor component's "options" prop
        cssMaxWidth: 550,
        includeUI: {
          loadImage: {
            path: this.imagesData.location,
            name: "SampleImage",
          },
          menuBarPosition: "bottom",
        },
      },
    };
  },

  components: {
    "tui-image-editor": ImageEditor,
  },

  methods: {
    onAddText(pos) {
      console.log(pos);
      var SINGLE_LINE = false;
      var canvas = new fabric.Canvas("canvas");
    },
    onObjectMoved(props) {
      console.log(props);
    },
    loadImageFromURL() {
      this.uiElements = this.$refs.tuiImageEditor.invoke("toDataURL");
      console.log(this.uiElements);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    loadImageFromURL() {
      //Original File
      // let dataURLtoFile = [];
      let originalFile = this.imagesData;
      let filename = this.imagesData.filename;
      let fileId = this.imagesData.file_id;
      //Edited File
      this.uiElements = this.$refs.tuiImageEditor.invoke("toDataURL");
      //Convert File
      let file = this.dataURLtoFile(this.uiElements, "edited_" + filename);
      //Call API
      var formData = new FormData();
      formData.append("file", file);
      this.$API.put(`files/${fileId}`, formData).then((result) => {
        console.log(result.data[0].location);
        if (result.data) {
          this.$vs.notify({
            title: "Success",
            color: "success",
            position: "top-center",
          });
          this.imagesData.location = result.data[0].location
          this.closeeditImage();
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.tui-image-editor-container {
  width: 1000px;
  height: 800px !important;
}
.tui-image-editor-header-logo {
  display: none;
}
.tui-image-editor-header-buttons {
  display: none;
}
.color-picker-control {
  display: block;
  top: -100px;
  overflow: scroll;
  left: -200px;
}
.tui-image-editor-container .color-picker-control {
  width: 400px;
}
</style>
